/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getShipmentTemplates } from "api/services/user";
import { IUserTemplates } from "types/Common";
import { userQueryKeys } from "./userQueryKeys";

export function useGetTemplates<T = IUserTemplates | undefined>(options: UseQueryOptions<T>) {
  return useQuery<T>({
    queryKey: userQueryKeys.userTemplates,
    queryFn: () => getShipmentTemplates().then((res) => res.data),
    ...options,
  });
}
